<template>
  
  <v-flex xs12 sm12 md12 class="mt-3">

    <!-- <h3>{{questionText}}</h3> -->

    <v-layout row class="mt-5">
      <v-flex shrink style="width: 60px">
        <v-text-field
          v-model="min"
          class="mt-0 mr-1"
          hide-details
          disabled
          single-line
          type="number"
        ></v-text-field>
      </v-flex>

      <v-slider
        :value="selected"
        v-model="selected"
        always-dirty
        thumb-label="always"
        :min="min"
        :max="max"
      ></v-slider>

      <v-flex shrink style="width: 60px">
        <v-text-field
          v-model="max"
          class="mt-0 ml-1"
          hide-details
          disabled
          single-line
          type="number"
        ></v-text-field>
      </v-flex>
    </v-layout>

  </v-flex>

</template>

<script>
// @ is an alias to /src

export default {
  name: "sliderbox",
  components: {
  },
  props: {
    question: Object
  },
  data: () => ({
    selected : null
  }),
  computed: {
    questionText() {
      return this.question.text;      
    },
    min() {
      return this.question.min;
    },
    max() {
      return this.question.max;
    }
  },
  watch: {
    selected() {
      const arg = {
        questionObj : this.question,
        answer : this.selected
      };
      this.$store.commit('setAnswerForQuestionObj', arg);
    }
  },
  created(){
    // Set the default value for the slider half way
    // this.selected = (this.min + this.max) / 2;
  },
  mounted() {
    
  },
  methods: {}
};
</script>

<style scoped>

</style>